import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColorPickerModule } from 'ngx-color-picker';
import { BrightnessContrastConfigModule, MaterialModule, ObjectFitConfigModule } from 'vhobjects-service';
import { NgZorroAntModule } from 'vhobjects-service';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { FormsModule } from '@angular/forms';
import { VhLanguagePipeModule } from 'vhobjects-service';
import { BordersConfigModule, HideShowConfigModule, LetterSpacingConfigModule, LineHeightConfigModule, PaddingConfigModule, ShadowConfigModule, SymbolConfigModule } from 'vhobjects-service';
import { VhStringPercentPipeModule } from 'vhobjects-service';
import { BordersRadiusConfigModule } from 'vhobjects-service';
import { ChooseAnimationsConfigModule } from 'vhobjects-service';
import { LinkPageModule } from 'vhobjects-service';
import { PositionOutConfigModule } from 'vhobjects-service';
import { RotateConfigModule } from 'vhobjects-service';
import { TextStyleConfigModule } from 'vhobjects-service';
import { WidthHeightConfigModule } from 'vhobjects-service';
import { TextFormatConfigModule } from 'vhobjects-service';
import { TranslateModule } from '@ngx-translate/core';
import { AnimationsConfigModule } from 'vhobjects-service';
import { AtwNewFieldInputAdminConfig } from './newField-input-admin-config/newField-input-admin-config.component';
import { AtwNewFieldSelectAdminConfig } from './newField-select-admin-config/newField-select-admin-config.component';
import { AtwNewFieldTextAdminConfig } from './newField-text-admin-config/newField-text-admin-config.component';
import { AtwCustomizeNewFieldAdminConfig } from './customize-newField-admin-config.component';
import { AtwNewFieldRadioButtonAdminConfig } from './newField-radio-button-admin-config/newField-radio-button-admin-config.component';
import { AtwNewFieldImageAdminConfig } from './newField-image-admin-config/newField-image-admin-config.component';

@NgModule({
  declarations: [
    AtwNewFieldInputAdminConfig,
    AtwNewFieldSelectAdminConfig,
    AtwNewFieldTextAdminConfig,
    AtwNewFieldRadioButtonAdminConfig,
    AtwCustomizeNewFieldAdminConfig,
    AtwNewFieldImageAdminConfig,
  ],
  imports: [
    CommonModule,
    ColorPickerModule,
    MaterialModule,
    NgZorroAntModule,
    ReactiveFormsModule,
    CKEditorModule,
    VhLanguagePipeModule,
    FormsModule,
    WidthHeightConfigModule,
    PositionOutConfigModule,
    LinkPageModule,
    ChooseAnimationsConfigModule,
    RotateConfigModule,
    TextStyleConfigModule,
    BordersConfigModule,
    BordersRadiusConfigModule,
    TextFormatConfigModule,
    TranslateModule,
    ShadowConfigModule,
    AnimationsConfigModule,
    HideShowConfigModule,
    SymbolConfigModule,
    VhStringPercentPipeModule,
    PaddingConfigModule,
    LetterSpacingConfigModule,
    LineHeightConfigModule,
    ObjectFitConfigModule,
    BrightnessContrastConfigModule
  ],
  exports: []
})
export class CustomizeNewFieldAdminConfigModule { }